import React, { Component } from 'react';
import _ from 'lodash';

import Image from '../../../../../components/ZUILib/Image';
import commonUtil from '../../../../../utils/commonUtil';
import HeaderFiltersBtns from '../wapComponents/HeaderFiltersBtns';
import CopyToClipBoardSvg from './CopyToClipBoardIcon';
import OtherGiftTables from './OtherGiftTables';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const isWap = channel === constChannels.WAP;

class HeaderEventData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: '',
      sortingType: '',
    };
    this.selectedCategory = '';
    this.giftsPerPage = this.props.giftsPerPage;
    this.textToCopy = null;
  }

  componentDidMount() {
    this.textToCopy = document.getElementById('textToCopy');
  }

  openFilterModal = () => {
    this.filterModal.handleShow();
  };

  showModal = () => {
    this.filterCategoryModal.handleShow();
  }

  closeCategoryFilterModal = () => {
    this.filterCategoryModal.handleHide();
    this.filterModal.handleShow();
  }

  closeFilterModal = () => {
    this.filterModal.handleHide();
  }

  handleCategorySelection = (e) => {
    const { getGiftListGuestView = () => {}, eventId, guestViewGiftListData = {} } = this.props;

    document.getElementById('clearFilterButton').className = 'btnClean';
    document.getElementById('clearCategoryFilterButton').className = 'btnClean';
    let category = '';
    if (e.id === 'Ascending' || e.id === 'Descending') {
      this.setState({ sortingType: e.id });
      getGiftListGuestView(eventId, e.id, this.state.category, '1', 'false', this.giftsPerPage);

      if (this.state.category) {
        this.selectedCategory = _.find(
          guestViewGiftListData.categoryList,
          { id: this.state.category }).name;
      }
    } else {
      this.setState({ category: e.id });
      category = e.id;

      getGiftListGuestView(
        eventId, this.state.sortingType, category, '1', 'false',
        this.giftsPerPage);

      this.selectedCategory = _.find(
        guestViewGiftListData.categoryList,
        { id: category }).name;
    }

    this.filterModal.handleHide();
    this.filterCategoryModal.handleHide();
  }

  clearSelectedValue = () => {
    const { getGiftListGuestView, eventId } = this.props || {};
    document.getElementById('clearFilterButton').className = 'btnClean disabled';
    document.getElementById('clearCategoryFilterButton').className = 'btnClean disabled';
    document.querySelectorAll("input[type='radio']:checked").forEach((e) => {
      e.checked = false;
    });
    this.setState({ category: '', sortingType: '' });
    getGiftListGuestView(eventId, 'Ascending', '', '1', 'false', this.giftsPerPage);
    this.selectedCategory = '';
  }

  setGifteeName = () => {
    const { onSetGifteeName } = this.props;
    const gifteeName = this.gifteeList.getID();
    onSetGifteeName(gifteeName);
  }

  typeOrder = (order) => {
    this.props.typeOrder(order, '');
  }

  getCategoryForHeader = (categoryId) => {
    this.props.getCategoryForHeader(categoryId);
  }

  render() {
    const { lables, guestViewGiftListData = '', getGiftListGuestView } = this.props;
    const labels = lables;
    const eventDateId = commonUtil.getLabel(labels.GuestviewPage, 'guestview.eventnumber.label');

    const eventInfo = guestViewGiftListData.eventInfo || '';
    const eventDate = eventInfo.eventDate || '';
    const eventId = eventInfo.eventId || '';
    const eventType = eventInfo.eventType || '';
    const celebratedList = guestViewGiftListData.celebratedList || [];

    const selectCelebratedName = celebratedList.map(selectedCelebratedName => ({
      id: selectedCelebratedName.celebratedId,
      value: selectedCelebratedName.celebratedName,
    }));

    const imageAttr = {
      id: 'img1',
      src: eventInfo.imageURL || '',
      altImg: commonUtil.getAssetURL() + '/images/avatar.svg',
      className: 'imageCustomEvent imageOwnerEvent',
      style: {
        height: isWap ? 126 : 152,
        maxWidth: isWap ? 126 : 152,
      },
    };

    const categoryList = {
      name: 'categoryList',
      options: [],
    };

    if (guestViewGiftListData && guestViewGiftListData.categoryList) {
      const newSet = new Set();
      guestViewGiftListData.categoryList.filter((category) => {
        if (newSet.has(category.name)) {
          return false;
        }
        newSet.add(category.name);
        return true;
      }).map(category =>
        categoryList.options.push({
          id: category.id,
          value: category.name,
          displayName: category.name,
        }),
      );
    }

    const eventName = eventInfo.eventName || '';

    return (
      <React.Fragment>
        <div className="headList wrapperHeaderCustomEvent">
          <h6 className="titleNameStaticName" style={{ fontWeight: 600 }} >{
            isWap ? eventName : 'Lista de Regalos' }
          </h6>
          <div className="imageCustomEvent" style={{ textAlign: 'center' }}>
            <Image imageAttr={imageAttr} />
          </div>

          <div className="contentEventHeader">
            {isWap ? '' : (<h6 className="titleNameCustomEvent" style={{ fontWeight: 600 }}>{ eventName }</h6>) }
            {
            selectCelebratedName.length > 0 &&
                selectCelebratedName.map(item => <p>{ item.value }</p>)
            }
            <p>{eventType}</p>
            <p className="eventDate">
              <img
                src={commonUtil.getAssetURL() + '/images/icons/event.svg'}
                alt="icon"
                style={{
                  width: '1.6rem',
                  height: '1.6rem',
                  verticalAlign: 'sub',
                  marginRight: '2px',
                }}
              />
              <span style={{ color: '#000' }}>{eventDate}</span></p>
            <p className="eventNumber">
              {eventDateId}:
              <div className="hoverLink" onClick={() => this.props.setCopyToClipboard(eventId)}>
                <span id="textToCopy">{eventId}</span>
                <span>
                  <CopyToClipBoardSvg />
                </span>
              </div>
            </p>
          </div>

          {
            !isWap && (
              <OtherGiftTables
                eventId={this.props.eventId}
                labels={this.props.lables}
                getDisplayStyle={this.props.getDisplayStyle}
              />
            )
          }
        </div>

        {
          isWap && (
            <HeaderFiltersBtns
              labels={labels}
              typeOrder={this.typeOrder}
              categoryList={categoryList}
              eventId={eventId}
              giftsPerPage={this.giftsPerPage}
              getCategoryForHeader={this.getCategoryForHeader}
              getGiftListGuestView={getGiftListGuestView}
            />
          )
        }

      </React.Fragment>
    );
  }
}
export default HeaderEventData;
